exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-create-page[data-v-821ab89e]{padding:20px 24px 32px}.order-create-page__container[data-v-821ab89e]{max-width:1080px}.order-create-page__topbar[data-v-821ab89e]{margin-bottom:16px}.order-create-page__tip[data-v-821ab89e]{margin-top:10px;padding-left:6px;color:#909399;font-size:13px}.order-create-page__card[data-v-821ab89e]{border:1px solid #ebeef5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-821ab89e","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/views/OrderCreate.vue
// module id = vngr
// module chunks = 0